import React, {useEffect} from "react";
import './DownloadApp.scss'
import Header from "../../components/Header";
import Footer from "../../components/Footer";

let img_1 = require("../../assets/download-app/Acquista-i-ticket.jpg");
let img_2 = require("../../assets/download-app/Copertina.jpg");
let img_3 = require("../../assets/download-app/Segna-catture.jpg");
let img_4 = require("../../assets/download-app/Segna-raccolta.jpg");
let img_top = require("../../assets/mushroom/26.webp");
let img_playstore = require("../../assets/download-app/playstore.webp");
let img_appstore = require("../../assets/download-app/appstore.png");
let logo = require("../../assets/logo-sm-light.png");

function DownloadApp() {
    useEffect(() => {
        document.title = "Geoticket - Scarica l'app";
    }, []);
    return (
        <div style={{backgroundColor: "#fafafa"}} className={"container-download-app"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Entra nel mondo di <span className={"orange"}>Geoticket</span>
                                </h1>
                                <h3>Scopri tutte le funzionalità dell'applicazione</h3>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container features mt-4 mb-4"}>
                <div className="row">
                    <div className="col-md-6 card">
                        <img width={240} src={img_1}/>
                        <b>Acquista i ticket</b>
                        <small className="text-muted">Tutti i permessi, in un click</small>
                        <p className={"text-center"}>Scegli il tuo territorio e acquista facilmente il ticket per
                            partire verso la tua nuova avventura.</p>
                    </div>

                    <div className="col-md-6 card">
                        <img width={240} src={img_2}/>
                        <b>Mappa intelligente</b>
                        <small className="text-muted">La tua guida digitale alla ricerca dei funghi</small>
                        <p className={"text-center"}>Scopri dove cercare in sicurezza e in modo efficace, con una mappa
                            intelligente che ti indica le zone migliori di crescita.</p>
                    </div>
                    <div className="col-md-6 card">
                        <img width={240} src={img_4}/>
                        <b>Segna raccolta</b>
                        <small className="text-muted">Salva i tuoi posti segreti</small>
                        <p className={"text-center"}>Tieni traccia delle tue zone di raccolta direttamente sulla mappa,
                            e non dimenticherai mai un buon punto.</p>
                    </div>
                    <div className="col-md-6 card">
                        <img width={240} src={img_3}/>
                        <b>Segna catture digitale</b>
                        <small className={"text-muted"}>Dimentica i fogli, segna tutto con un click</small>
                        <p className={"text-center"}>Registra le tue catture in tempo reale, senza stress e con
                            facilità, per avere i tuoi ricordi sempre a portata di smartphone.</p>
                    </div>
                </div>
            </div>
            <div className="container-row">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 d-flex justify-content-center align-items-center">
                            <img width={120} src={logo}/>

                        </div>
                        <div className="col-md-6 d-flex justify-content-center align-items-center flex-column">
                            <h3>Scarica l'App</h3>
                            <div className={"d-flex  flex-row"}>
                                <a href={"https://play.google.com/store/apps/details?id=com.geoticket"}>
                                    <img width={140} src={img_playstore}/>
                                </a>
                                <a href={"https://apps.apple.com/us/app/geoticket/id1475238989"}>
                                    <img width={140} src={img_appstore}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default DownloadApp;